module.exports = __webpack_public_path__ + "static/media/algae4.c7799e40.svg";